module.exports = __webpack_public_path__ + "img/bgc11.a6988738.png";